import classNames from "classnames";
import React, { Fragment } from "react";
import { materials } from "../../data/cards";
import { cardImageForMaterial } from "../card-images";
import "./Stockpile.css";

function Stockpile({ stockpile, config: { showZero } }) {
  return (
    <div className="mini-Stockpile">
      {materials
        .map((m) => [
          m,
          (stockpile || []).filter(({ material }) => material === m).length,
        ])
        .filter(([_, count]) => count > 0 || showZero)
        .map(([m, count], index) => (
          <Fragment key={m}>
            <div
              className={classNames("tag", cardImageForMaterial(m))}
              style={{ gridColumn: 1 + index, gridRow: 1 }}
            />
            <div
              className="value"
              style={{ gridColumn: 1 + index, gridRow: 2 }}
            >
              {count}
            </div>
          </Fragment>
        ))}
    </div>
  );
}

export default Stockpile;
